import { IEntityMinimalModel, ILockableEntityParameters } from "../../../../api/GenericTypes";
import { toValidDate } from "../../../datetime/DateTimeFormatter";

export interface ILockableEntityForm {
  lockedByIds?: IEntityMinimalModel[] | undefined | null;
  lockedFrom?: Date | undefined | null;
  lockedTo?: Date | undefined | null;
  isLocked?: boolean | undefined | null;
}

export const LockableEntityDefaultFilterFormValues: Required<ILockableEntityForm> = {
  lockedByIds: null,
  lockedFrom: null,
  lockedTo: null,
  isLocked: null,
};

export const lockableEntityFormToFilters = <Filters extends Partial<ILockableEntityParameters>>(
  form: ILockableEntityForm
): Filters => {
  let filters = {} as Filters;
  filters.lockedByIds =
    Array.isArray(form.lockedByIds) && form.lockedByIds.length > 0 ? form.lockedByIds?.map((d) => d.id) : null;
  filters.lockedFrom = toValidDate(form.lockedFrom);
  filters.lockedTo = toValidDate(form.lockedTo);
  filters.isLocked = form.isLocked ?? null;
  return filters;
};

export const lockableEntityFiltersToForm = (filters: Partial<ILockableEntityParameters>): ILockableEntityForm => {
  return {
    lockedByIds: filters.lockedByIds ? filters.lockedByIds.map((id) => ({ id, name: "" })) : null,
    lockedFrom: filters.lockedFrom ? new Date(filters.lockedFrom) : null,
    lockedTo: filters.lockedTo ? new Date(filters.lockedTo) : null,
    isLocked: filters.isLocked ?? null,
  };
};
